import { type StringSelectOption } from "@tellescope/ui";
import { type TagsBehavior } from "./contactFilters";
import { i18n } from "@tellescope/i18n";

export const getTagsBehaviorOptions: () => StringSelectOption<TagsBehavior>[] = () => [
  { value: "match_any", label: i18n.t("Match Any", { ns: "contacts" }) },
  { value: "match_all", label: i18n.t("Match All", { ns: "contacts" }) },
  { value: "match_none", label: i18n.t("Match None", { ns: "contacts" }) },
];
